var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconControl128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16536)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 16.5027C90.5097 16.5027 112 37.993 112 64.5027C112 91.0124 90.5097 112.503 64 112.503C37.4903 112.503 16 91.0124 16 64.5027C16 37.993 37.4903 16.5027 64 16.5027ZM100.936 74.1019L89.605 74.1027C78.7416 74.1027 69.935 82.9075 69.935 93.7892L69.9372 102.197C85.0129 99.8418 97.1637 88.659 100.936 74.1019ZM56.3681 101.893L56.3692 93.7892C56.3692 82.9166 47.5407 74.1027 36.6934 74.1027L27.0639 74.1019C30.6939 88.1094 42.0815 98.9926 56.3681 101.893ZM64 26.3488C46.7809 26.3488 32.2259 37.7555 27.4792 53.4248H100.521C95.7741 37.7555 81.2191 26.3488 64 26.3488Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0005 77.3933C69.009 77.3933 73.0693 73.333 73.0693 68.3244C73.0693 63.3159 69.009 59.2556 64.0005 59.2556C58.9919 59.2556 54.9316 63.3159 54.9316 68.3244C54.9316 73.333 58.9919 77.3933 64.0005 77.3933Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconControl128);
export default __webpack_public_path__ + "static/media/pictogramBeaconControl128.c5573c96ebd1f9a8a257414012255577.svg";
export { ForwardRef as ReactComponent };